import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="sticky top-0 z-20 bg-white/85 backdrop-blur-xl border-b border-slate-200">
      <div className="px-4 md:px-6 lg:px-8 py-4 md:py-5 flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <div className="label-caps mb-1">{subtitle || "Broker OMS"}</div>
          <h1 className="font-display text-2xl md:text-3xl tracking-tight text-slate-900 truncate" data-testid={testid || "page-title"}>{title}</h1>
        </div>
        <div className="flex items-center gap-2 flex-wrap">{actions}</div>
      </div>
    </div>
  );
}

export function PageBody({ children }) {
  return <div className="p-4 md:p-6 lg:p-8">{children}</div>;
}

export function StatusBadge({ status }) {
  const map = {
    open: "bg-blue-50 text-blue-700 ring-blue-700/10",
    partial: "bg-amber-50 text-amber-700 ring-amber-700/10",
    converted: "bg-emerald-50 text-emerald-700 ring-emerald-700/10",
    closed: "bg-slate-100 text-slate-700 ring-slate-700/10",
    rejected: "bg-red-50 text-red-700 ring-red-700/10 line-through",
    in_progress: "bg-indigo-50 text-indigo-700 ring-indigo-700/10",
    completed: "bg-emerald-50 text-emerald-700 ring-emerald-700/10",
    pending: "bg-slate-100 text-slate-700 ring-slate-700/10",
    ordered: "bg-blue-50 text-blue-700 ring-blue-700/10",
    shipped: "bg-indigo-50 text-indigo-700 ring-indigo-700/10",
    delivered: "bg-emerald-50 text-emerald-700 ring-emerald-700/10",
    shipped_to_customer: "bg-teal-50 text-teal-700 ring-teal-700/10",
    cancelled: "bg-rose-50 text-rose-700 ring-rose-700/10 line-through",
  };
  const cls = map[status] || "bg-slate-100 text-slate-700 ring-slate-700/10";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-mono uppercase tracking-wider rounded-sm ring-1 ring-inset ${cls}`}>
      {status || "-"}
    </span>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="border border-dashed border-slate-300 bg-white p-12 text-center">
      <div className="font-display text-lg text-slate-800">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function formatMoney(amount, currency = "USD", minDecimals) {
  if (amount == null || isNaN(amount)) return "-";
  try {
    const opts = { style: "currency", currency };
    if (minDecimals != null) {
      opts.minimumFractionDigits = minDecimals;
      // let currency default max win, but ensure it's at least minDecimals
      opts.maximumFractionDigits = Math.max(minDecimals, 2);
    }
    return new Intl.NumberFormat("en-US", opts).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}
